package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.remote.AppFirestore
import com.evoapps.evoshift.domain.repository.ReviewPromptRepository
import com.evoapps.evoshift.domain.util.AppClock
import kotlin.time.Instant
import kotlinx.serialization.Serializable

/** `users/{uid}/settings/review` (SH-240): only the date of the last store rating prompt. */
@Serializable
internal data class ReviewPromptDto(
    val lastPromptAt: String? = null,
    val updatedAt: String? = null
)

class ReviewPromptRepositoryImpl(private val firestore: AppFirestore) : ReviewPromptRepository {
    private fun document(userId: String) =
        firestore.collection("users").document(userId).collection("settings").document("review")

    override suspend fun lastPromptAt(userId: String): Instant? = runCatching {
        val snapshot = document(userId).get()
        if (!snapshot.exists) null
        else snapshot.data<ReviewPromptDto>().lastPromptAt?.let { Instant.parse(it) }
    }.getOrNull()

    override suspend fun savePromptAt(userId: String, at: Instant): Result<Unit> = runCatching {
        document(userId).set(ReviewPromptDto(lastPromptAt = at.toString(), updatedAt = AppClock.now().toString()))
    }
}
